module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 25.62c62ae0.png";